module.exports = __webpack_public_path__ + "img/image-thumb-14.4f7d0f49.jpg";